"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const common_1 = require("../../../../../../common");
const bondsList = [
    { value: 'balance-rr', label: 'Balance-rr (0)', default: false },
    { value: 'active-backup', label: 'Active-Backup (1)', default: true },
    { value: 'balance-xor', label: 'Balance-xor (2)', default: false },
    { value: 'broadcase', label: 'Broadcase (3)', default: false },
    { value: '802.3ad', label: '802.3ad (4)', default: false },
    { value: 'balance-tlb', label: 'Balance-tlb (5)', default: false },
    { value: 'balance-alb', label: 'Balance-alb (6)', default: false },
];
const BondsSelect = ({ onChange, name }) => {
    const selectOptions = bondsList.map((version) => ({
        label: version.label,
        value: version.value,
    }));
    return (react_1.default.createElement(common_1.SelectField, { name: name, label: "Bond type", options: selectOptions, isRequired: true, onChange: onChange }));
};
exports.default = BondsSelect;
//# sourceMappingURL=BondsSelect.js.map